module.exports = __webpack_public_path__ + "img/threeFingerThrowText2.030c75a9.png";